import { render } from "./HomeCard.vue?vue&type=template&id=1f0f076f&scoped=true"
import script from "./HomeCard.vue?vue&type=script&lang=js"
export * from "./HomeCard.vue?vue&type=script&lang=js"

import "./HomeCard.vue?vue&type=style&index=0&id=1f0f076f&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f0f076f"]])

export default __exports__